import { Paper, PaperProps, Stack } from "@mui/material";
import classNames from "classnames";
import { makeStyles } from "components/providers/makeStyles";
import { mergeSx, Sx } from "utils/sx";

export const EVENT_CARD_WIDTH = 40;

const useStyles = makeStyles(theme => ({
    background: {
        "--background-color": theme.palette.background.lowest,
        "--background-color-live": theme.palette.secondary.lighter,
        "--background-color-details": theme.palette.background.low,
        "--background-color-details-live": theme.palette.secondary.light,
        "&:hover:not(.skeleton *)": {
            "--background-color": theme.palette.background.low,
            "--background-color-live": theme.palette.secondary.light,
            "--background-color-details": theme.palette.background.mid,
            "--background-color-details-live": theme.palette.secondary.main,
        },
    }
}));

export const EventCard: React.FCWithChildren<PaperProps & { fullWidth?: boolean }> = ({
    children,
    fullWidth,
    sx,
    className,
    ...props
}) => {
    const styles: Sx = theme => ({
        borderRadius: theme.spacing(1),
        borderColor: theme.palette.border.light,
        borderWidth: theme.spacing(.125),
        width: theme.spacing(fullWidth ? "100%" : EVENT_CARD_WIDTH),
        overflow: "hidden",
    });

    const { background } = useStyles();

    return (
        <Paper
            variant="outlined"
            sx={mergeSx(styles, sx)}
            className={classNames(background, className)}
            {...props}
        >
            <Stack direction="column">
                {children}
            </Stack>
        </Paper>
    );
};
